import { render, staticRenderFns } from "./StreamPlayerWebRtc.vue?vue&type=template&id=77f7f261&scoped=true"
import script from "./StreamPlayerWebRtc.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamPlayerWebRtc.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StreamPlayerWebRtc.vue?vue&type=style&index=0&id=77f7f261&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f7f261",
  null
  
)

export default component.exports